import { Injectable } from '@angular/core';
import { appSettings, errorMessages } from "../../settings";
import { CommonService } from "../common.service";
import { WidgethelperService } from "../widgethelper.service";
import { BaseService } from "./base.service";

@Injectable()
export class OpenordersService extends BaseService{

  constructor(
    private _commonService: CommonService,
    private _widgetHelper: WidgethelperService
  ) { 
    super();
  }

  init(widget: any) {
    this._widgetHelper.CreateHub(widget)
    this.DisplayData(widget);
  }

  DisplayData(widget: any) {
    widget.hub.listenFor("broadcastOpenOrders").subscribe(
      (result: any) => {
        // console.log("broadcastOpenOrders", result);
        let resultwid;
        let resultcreationtime;
        let lastUpdatedTime;

        if (result && result.length > 0) {
          //console.log(result[0].IsNoDataFound);
          widget.IfNoDataFound = result[0].IsNoDataFound;
          resultwid = result[0].widgetid;
          resultcreationtime = result[0].widgetcreationtime;
          lastUpdatedTime = result[0].LastUpdateTime;
        }
        else {
          widget.errorMessage = errorMessages.noWidgetData;
        }

        if (resultwid == widget.widgetId && resultcreationtime == widget.widgetcreationtime) {
          widget.dataLoaded = false;
          widget.chartOptions = this.chartOptions();
          widget.errorMessage = null;
          if(widget.IfNoDataFound){
            widget.errorMessage = errorMessages.noWidgetData;
          }else if (widget.IfNoDataFound == null) {
            widget.errorMessage = "Retrieving records. Please wait...";
          }
          else{
            widget.Title = 'Customer Open Orders';
            let Report_Periods = [];
            let xAxisData:string[] = [];
            let CodeDescription = [];            
            let seriesData = [];

            result = result.sort((a, b) => {
              if (a.REPORT_DATE < b.REPORT_DATE) return -1;
              else if (a.REPORT_DATE > b.REPORT_DATE) return 1;
              else return 0;
            });

            result.forEach(element => {
              let rptdate = "";
              rptdate = element.REPORT_DATE;
              let codeDesc = "";
              codeDesc = element.CODE_DESCRIPTION;
              if (rptdate != '' && Report_Periods.indexOf(rptdate) == -1) {
                Report_Periods.push(rptdate);
                xAxisData.push(this._commonService.formatDate(new Date(rptdate),appSettings.chartDayFormat))
              }
              if (codeDesc != '' && CodeDescription.indexOf(codeDesc) == -1) {
                CodeDescription.push(codeDesc);
                seriesData.push({OrderData:[], QuantityData:[], Legend:codeDesc.trim()});
              }
            });

            
            // let seriesData = [];
            Report_Periods.forEach(element => { 
              CodeDescription.forEach(item => {
                let objResult = result.find(d => ((d.REPORT_DATE == element) && (d.CODE_DESCRIPTION.trim() == item.trim())) );                
                let existItem = seriesData.find(sd => ((sd.Legend.trim() == item.trim())) );
                if (objResult){
                  existItem.OrderData.push(objResult.ORDER_COUNT);
                  existItem.QuantityData.push(objResult.QUANTITY_COUNT);
                }
                else{
                  existItem.OrderData.push(null);
                  existItem.QuantityData.push(null);
                }
              });
            });

            seriesData.forEach(sd => {
              this.addDataSeries(widget.chartOptions, sd.OrderData, sd.Legend + "-Order Count", 'line');
              this.addDataSeries(widget.chartOptions, sd.QuantityData, sd.Legend + "-Quantity Count", 'line');
            });
            
            this.addZoomBar(widget.chartOptions);
            widget.chartOptions.xAxis.data = xAxisData;
            widget.chartOptions.xAxis.axisLabel.rotate = 45;
          }
        }
        // console.log('widget options:',widget.chartOptions);
        widget.dataLoaded = true;
        this._commonService.lastUpdatedTime = lastUpdatedTime;
        
      },
      err => {
        console.log("listenFor broadcastOpenOrders error", err);
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/services/widgets/openorders.service.ts